<div class="gpd-full-page config-schedule-page">
  <div class="gpd-header-container">
    <dx-select-box
      class="gpd-input"
      [items]="areaTypes"
      [(value)]="areaTypeId"
      (onValueChanged)="onAreaTypeChanged($event)"
      valueExpr="id"
      displayExpr="name"
      [width]="250"
    >
    </dx-select-box>
  </div>
  <div class="schedule-container">
    <dx-gantt
      #gantt
      class="gpd-gantt gpd-disable-progress"
      scaleType="weeks"
      taskTitlePosition="none"
      taskContentTemplate="taskContentTemplate"
      (onScaleCellPrepared)="onScaleCellPrepared($event)"
      height="100%"
      width="100%"
      [startDateRange]="startGantt"
      (onTaskMoving)="onTaskMoving($event)"
      [firstDayOfWeek]="0"
      (onTaskUpdated)="onTaskUpdated($event)"
      (onTaskUpdating)="onTaskUpdating($event)"
      (onDependencyInserted)="onDependencyInserted($event)"
      (onDependencyDeleted)="onDependencyDeleted($event)"
      taskTooltipContentTemplate="taskTooltipContentTemplate"
      (onTaskEditDialogShowing)="$event.cancel = true"
      taskTimeTooltipContentTemplate="taskTimeTooltipContentTemplate"
      (onContextMenuPreparing)="onContextMenuPreparing($event)"
      (onDependencyInserting)="onDependencyInserting($event)"
    >
      <dxo-gantt-context-menu [enabled]="true"></dxo-gantt-context-menu>
      <dxi-strip-line [start]="firstMonday" title="Now" cssClass="start-time"> </dxi-strip-line>
      <dxo-toolbar>
        <dxi-item name="zoomIn" menuItemTemplate="itemTemplate">
          <div *dxTemplate="let data of 'itemTemplate'">
            <app-gpd-button
              icon="search-add"
              type="text"
              (onClick)="data.item.onClick()"
              color="var(--color-primary)"
            ></app-gpd-button>
          </div>
        </dxi-item>
        <dxi-item name="zoomOut" menuItemTemplate="itemTemplate">
          <div *dxTemplate="let data of 'itemTemplate'">
            <app-gpd-button
              icon="search-minus"
              type="text"
              (onClick)="data.item.onClick()"
              color="var(--color-primary)"
            ></app-gpd-button>
          </div>
        </dxi-item>
        <dxi-item name="safeMode" *ngIf="isAdmin">
          <div *dxTemplate class="safe-mode-container">
            <dx-check-box
              class="gpd-input"
              i18n-text="@@safeMode"
              text="Safe Mode"
              [(value)]="safeMode"
              (onValueChanged)="onSafeModeChanged($event)"
            ></dx-check-box>
            <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-config-schedule" [size]="16"></app-svg-icon>
            <dx-popover
              target=".help-icon-config-schedule"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              [wrapperAttr]="{ class: 'gpd-popover' }"
              position="bottom"
              style="display: none"
            >
              <div class="help-context" i18n="@@safeModeHelp">
                When enabled, the plan automatically ensures a logical chronological order of connected elements and
                prevents circular dependencies. If the option is disabled, all elements can be moved freely.
              </div>
            </dx-popover>
          </div>
        </dxi-item>
      </dxo-toolbar>
      <dxo-gantt-scale-type-range max="months" min="days"></dxo-gantt-scale-type-range>
      <dxo-validation
        [autoUpdateParentTasks]="true"
        [validateDependencies]="safeMode"
        [enablePredecessorGap]="true"
      ></dxo-validation>
      <dxo-tasks
        [dataSource]="ganttTasks"
        keyExpr="id"
        parentIdExpr="parentId"
        endExpr="endDate"
        startExpr="startDate"
        titleExpr="title"
        colorExpr="color"
      ></dxo-tasks>
      <dxo-dependencies
        [dataSource]="ganttDependancies"
        keyExpr="id"
        successorIdExpr="taskId"
        typeExpr="dependencyType"
        predecessorIdExpr="dependancyOnId"
      ></dxo-dependencies>
      <dxi-column dataField="sortingIndex" [visible]="false" [sortIndex]="0" sortOrder="asc"></dxi-column>
      <dxi-column dataField="title" i18n-caption="@@title" caption="Title"></dxi-column>

      <div *dxTemplate="let data of 'taskTooltipContentTemplate'">
        <div class="tooltip-content">
          <div class="tooltip-title">{{ data.title }}</div>
          <div class="tooltip-row">
            <span class="row-title" i18n="@@start">Start</span>
            <span class="row-value">
              <span i18n="@@week">Week</span>
              {{ getRelativeWeekNumber(data.startDate) + 1 }} | <span i18n="@@day">Day</span>
              {{ data.startDate.getDay() + 1 }}
            </span>
          </div>
          <div class="tooltip-row">
            <span class="row-title" i18n="@@end">End</span>
            <span class="row-value">
              <span i18n="@@week">Week</span>
              {{ getRelativeWeekNumber(data.endDate) + 1 }} | <span i18n="@@day">Day</span>
              {{ data.endDate.getDay() + 1 }}
            </span>
          </div>

          <div class="tooltip-row">
            <span class="row-title" i18n="@@duration">Duration</span>
            <span class="row-value"
              >{{ getDuration(data.startDate, data.endDate) }} <span i18n="@@days">days</span></span
            >
          </div>
        </div>
      </div>

      <div *dxTemplate="let data of 'taskTimeTooltipContentTemplate'">
        <div class="tooltip-content">
          <div class="tooltip-row">
            <span class="row-title" i18n="@@start">Start</span>
            <span class="row-value">
              <span i18n="@@week">Week</span>
              {{ getRelativeWeekNumber(data.start) + 1 }} | <span i18n="@@day">Day</span> {{ data.start.getDay() + 1 }}
            </span>
          </div>
          <div class="tooltip-row">
            <span class="row-title" i18n="@@end">End</span>
            <span class="row-value">
              <span i18n="@@week">Week</span>
              {{ getRelativeWeekNumber(data.end) + 1 }} | <span i18n="@@day">Day</span> {{ data.end.getDay() + 1 }}
            </span>
          </div>

          <div class="tooltip-row">
            <span class="row-title" i18n="@@duration">Duration</span>
            <span class="row-value">{{ getDuration(data.start, data.end) }} <span i18n="@@days">days</span></span>
          </div>
        </div>
      </div>
      <dxo-editing
        [enabled]="true"
        [allowDependencyDeleting]="true"
        [allowTaskAdding]="false"
        [allowTaskDeleting]="false"
      >
      </dxo-editing>

      <div *dxTemplate="let item of 'taskContentTemplate'">
        <div class="schedule-task-wrapper">
          <div
            class="schedule-task {{item.taskData.itemType}}"
            style.width="{{ item.taskSize.width }}px"
            [style.background-color]="item.taskData.color"
          ></div>
        </div>
      </div>
    </dx-gantt>
  </div>
</div>

<app-generic-popup [visible]="showDisableDeps" i18n-title="@@disableDependencies" title="Disable dependencies" [allowOutsideClick]="false">
  <div class="disable-deps-content">
    <p i18n="@@disableDependenciesMessage1">
      If this option is disabled, all items in the schedule can be moved freely. Temporal dependencies are no longer
      checked automatically.
    </p>

    <div class="warning-box">
      <app-svg-icon icon="alert" color="var(--color-task)" class="warning-icon" [size]="20" />
      <div class="warning-content">
        <p i18n="@@disableDependenciesMessage2" style="font-weight: 500">
          This can lead to circular dependencies—i.e., dependencies that contradict each other and no longer allow for a
          clear sequence of events.
        </p>
        <p i18n="@@disableDependenciesMessage3">
          In such cases, the schedule can no longer be processed correctly, which can lead to severely limited
          functionality or unexpected behavior of the system.
        </p>
      </div>
    </div>

    <dx-check-box
      class="gpd-input"
      [(value)]="dontshowAgain"
      (onValueChanged)="onDontShowAgainChanged($event)"
      i18n-text="@@dontShowAgain"
      text="Don't show this message again."
    ></dx-check-box>
  </div>
  <div popup-actions class="action-container">
    <app-gpd-button
      type="secondary"
      i18n-text="@@cancel"
      text="Cancel"
      (onClick)="showDisableDeps = false; safeMode = true"
    ></app-gpd-button>
    <app-gpd-button
      type="primary"
      i18n-text="@@disable"
      text="Disable"
      (onClick)="showDisableDeps = false"
    ></app-gpd-button>
  </div>
</app-generic-popup>

<app-generic-popup [visible]="showCircularDepError" i18n-title="@@notAllowed" title="Not allowed">
  <div class="circular-dep-content">
    <p i18n="@@circularDependencyError1">
      This action would create a circular dependency and is therefore not allowed.
    </p>
    <p i18n="@@circularDependencyError2">
      An element cannot be linked to
      another element if elements contained within or associated with it are already linked to the same element. Please
      adjust the existing dependencies.
    </p>
    <p i18n="@@circularDependencyError3" style="font-weight: 500;">
      Please adjust the existing dependencies.
    </p>
  </div>
  <div popup-actions class="action-container">
    <app-gpd-button type="primary" i18n-text="@@ok" text="OK" (onClick)="showCircularDepError = false"></app-gpd-button>
  </div>
</app-generic-popup>
